import './Skeleton.css';

/**
 * Bloque de carga (placeholder animado).
 * - width / height: medidas CSS (ej. '60%', '120px')
 * - radius: borde redondeado (ej. '50%' para avatar)
 */
export default function Skeleton({ width = '100%', height = 12, radius = 6, style, className = '' }) {
  return (
    <span
      className={`skeleton ${className}`}
      style={{ width, height, borderRadius: radius, ...style }}
      aria-hidden="true"
    />
  );
}